// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.goodiesCard {
  display: flex;
  /* justify-content: space-between; */
  /* max-width: 20rem; */
  /* background: var(--clr-light); */
  background: var(--clr-secondary);
  /* padding: 2em; */
  /* padding: 1.25em 1em; */
  /* gap: 2rem; */
  gap: 1rem;
  /* min-height: 5rem; */
  max-height: 18rem;
  align-items: center;
  overflow: hidden;
  /* border-radius: 0.5em; */
}

.goodiesCard__btn .cross-mark {
  /* margin-left: -0.75rem; */
  margin-left: -0.15rem;
  margin-bottom: -0.5rem;
  width: -moz-fit-content;
  width: fit-content;
}

.goodiesCard__btn .cross-mark::before,
.goodiesCard__btn .cross-mark::after {
  background: #fff;
}

.goodiesCard__details {
  padding: 1em 1em 1em 0;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  display: flex;
  max-width: 13rem;
  flex-direction: column;
  /* padding: 0 1em; */
}

.goodiesCard__text {
  font-size: 0.85rem;
  /* max-width: 9rem; */
  /* flex: 1 1 50%; */
  /* height: 100%; */
  line-height: 1.8;
  color: var(--clr-gray600);
}

.goodiesCard__text p {
  color: var(--clr-gray600);
}

.goodiesCard__text > span:hover {
  cursor: pointer;
  font-weight: bold;
  color: var(--clr-primary);
}

.goodiesCard__text h3 {
  color: var(--clr-primary);
  line-height: 1.5;
  font-weight: bolder;
  cursor: pointer;
}

.goodiesCard__iconContainer {
  /* border-radius: 50%; */
  overflow: hidden;
  height: 100%;
  width: 25rem;
  /* border: 0.3rem solid var(--clr-primary); */
}

.goodiesCard__iconContainer .swiper-container {
  height: 100%;
}

.goodiesCard__icon {
  /* width: 100%;
  max-width: 2.5rem;
  max-width: 3rem;
  maxw
  display: block; */
  width: 100%;
  height: 100%;
  /* max-width: 3rem; */
  object-fit: contain;
  position: relative;
  z-index: 10;
  display: block;
}

.goodiesCard__iconContainer {
  width: 100%;
  height: 100%;
  max-width: 11rem;
  object-fit: contain;
  display: block;
  overflow: hidden;
  position: relative;
}

.goodiesCard__iconContainer .loading-dot {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  font-size: 0.8rem;
}
/* 
.goodiesCard__iconContainer::after {
  display: flex;
  content: "charger l'image...";
  position: absolute;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-left: -2rem;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  font-size: 0.8rem;
} */

/* 
.goodiesCard__iconContainer::after {
  display: block;
  content: "";
  position: absolute;
  top: 0;
  width: 100%;
  height: 85%;
  transform: translateX(-100%);
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(transparent),
    color-stop(rgba(255, 255, 255, 0.74)),
    to(transparent)
  );

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.74),
    transparent
  );

  animation: loadingSkeleton 0.8s infinite;
} */

.goodiesCard__btn {
  display: grid;
  place-items: center;
  width: 100%;
  max-width: 2.5rem;
  height: 2.5rem;
  padding: 0;
}

.goodiesCard__btn svg {
  display: block;
  width: 2rem;
}

.activitiesCard__btnNext {
  display: flex;
  position: absolute;
  border-radius: 1em;
  top: -4.5rem;
  background: transparent;
  color: var(--clr-primary);
  border: 0.1rem solid var(--clr-gray400);
  right: 1rem;
  background: var(--clr-main-bg);
}

.activitiesCard__btnNext svg {
  width: 1rem;
  margin-left: 0.5rem;
}

.goodiesCard__btn,
.filterBar__counter {
  margin: 0 !important;
  margin-left: auto !important;
  /* margin-top: 1rem; */
}

.goodiesCard__textPrice span {
  font-size: 1.15rem;
  color: var(--clr-primary);
  font-weight: bold;
}

.goodiesCard__textPrice {
  font-size: 0.85rem;
  line-height: 1.5;
  margin-top: 0.5rem;
  color: var(--clr-gray500);
}

@media (min-width: 375px) {
  .homeActivities__container {
    grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
  }

  .goodiesCard {
    /* max-width: 20rem; */
    /* padding: 1.5em 1.25em; */
    gap: 1rem;
  }

  .goodiesCard__details {
    padding: 1em 1em 1em 0;
  }

  /* .goodiesCard__icon {
    width: 100%;
    max-width: 4.5rem;
    max-width: 3rem;
    display: block;
  } */
}
`, "",{"version":3,"sources":["webpack://./src/components/CoffretComponents/GoodiesComponents/GoodiesCard/GoodiesCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;;;mBAIiB;EACjB,WAAW;EACX,YAAY;EAEZ,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,iBAAiB;AACnB;AACA;;;;;;;;;;;;;;;GAeG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,uCAAuC;EACvC,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;;KAKG;AACL","sourcesContent":[".goodiesCard {\n  display: flex;\n  /* justify-content: space-between; */\n  /* max-width: 20rem; */\n  /* background: var(--clr-light); */\n  background: var(--clr-secondary);\n  /* padding: 2em; */\n  /* padding: 1.25em 1em; */\n  /* gap: 2rem; */\n  gap: 1rem;\n  /* min-height: 5rem; */\n  max-height: 18rem;\n  align-items: center;\n  overflow: hidden;\n  /* border-radius: 0.5em; */\n}\n\n.goodiesCard__btn .cross-mark {\n  /* margin-left: -0.75rem; */\n  margin-left: -0.15rem;\n  margin-bottom: -0.5rem;\n  width: fit-content;\n}\n\n.goodiesCard__btn .cross-mark::before,\n.goodiesCard__btn .cross-mark::after {\n  background: #fff;\n}\n\n.goodiesCard__details {\n  padding: 1em 1em 1em 0;\n  justify-content: space-between;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  max-width: 13rem;\n  flex-direction: column;\n  /* padding: 0 1em; */\n}\n\n.goodiesCard__text {\n  font-size: 0.85rem;\n  /* max-width: 9rem; */\n  /* flex: 1 1 50%; */\n  /* height: 100%; */\n  line-height: 1.8;\n  color: var(--clr-gray600);\n}\n\n.goodiesCard__text p {\n  color: var(--clr-gray600);\n}\n\n.goodiesCard__text > span:hover {\n  cursor: pointer;\n  font-weight: bold;\n  color: var(--clr-primary);\n}\n\n.goodiesCard__text h3 {\n  color: var(--clr-primary);\n  line-height: 1.5;\n  font-weight: bolder;\n  cursor: pointer;\n}\n\n.goodiesCard__iconContainer {\n  /* border-radius: 50%; */\n  overflow: hidden;\n  height: 100%;\n  width: 25rem;\n  /* border: 0.3rem solid var(--clr-primary); */\n}\n\n.goodiesCard__iconContainer .swiper-container {\n  height: 100%;\n}\n\n.goodiesCard__icon {\n  /* width: 100%;\n  max-width: 2.5rem;\n  max-width: 3rem;\n  maxw\n  display: block; */\n  width: 100%;\n  height: 100%;\n  position: relative;\n  /* max-width: 3rem; */\n  object-fit: contain;\n  position: relative;\n  z-index: 10;\n  display: block;\n}\n\n.goodiesCard__iconContainer {\n  width: 100%;\n  height: 100%;\n  max-width: 11rem;\n  object-fit: contain;\n  display: block;\n  overflow: hidden;\n  position: relative;\n}\n\n.goodiesCard__iconContainer .loading-dot {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  font-size: 0.8rem;\n}\n/* \n.goodiesCard__iconContainer::after {\n  display: flex;\n  content: \"charger l'image...\";\n  position: absolute;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-left: -2rem;\n  height: 100%;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  font-size: 0.8rem;\n} */\n\n/* \n.goodiesCard__iconContainer::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 85%;\n  transform: translateX(-100%);\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(transparent),\n    color-stop(rgba(255, 255, 255, 0.74)),\n    to(transparent)\n  );\n\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.74),\n    transparent\n  );\n\n  animation: loadingSkeleton 0.8s infinite;\n} */\n\n.goodiesCard__btn {\n  display: grid;\n  place-items: center;\n  width: 100%;\n  max-width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n}\n\n.goodiesCard__btn svg {\n  display: block;\n  width: 2rem;\n}\n\n.activitiesCard__btnNext {\n  display: flex;\n  position: absolute;\n  border-radius: 1em;\n  top: -4.5rem;\n  background: transparent;\n  color: var(--clr-primary);\n  border: 0.1rem solid var(--clr-gray400);\n  right: 1rem;\n  background: var(--clr-main-bg);\n}\n\n.activitiesCard__btnNext svg {\n  width: 1rem;\n  margin-left: 0.5rem;\n}\n\n.goodiesCard__btn,\n.filterBar__counter {\n  margin: 0 !important;\n  margin-left: auto !important;\n  /* margin-top: 1rem; */\n}\n\n.goodiesCard__textPrice span {\n  font-size: 1.15rem;\n  color: var(--clr-primary);\n  font-weight: bold;\n}\n\n.goodiesCard__textPrice {\n  font-size: 0.85rem;\n  line-height: 1.5;\n  margin-top: 0.5rem;\n  color: var(--clr-gray500);\n}\n\n@media (min-width: 375px) {\n  .homeActivities__container {\n    grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));\n  }\n\n  .goodiesCard {\n    /* max-width: 20rem; */\n    /* padding: 1.5em 1.25em; */\n    gap: 1rem;\n  }\n\n  .goodiesCard__details {\n    padding: 1em 1em 1em 0;\n  }\n\n  /* .goodiesCard__icon {\n    width: 100%;\n    max-width: 4.5rem;\n    max-width: 3rem;\n    display: block;\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
